export const Maze = {
  BORDER: 1,
}

// Use i to place items in the mazes
// What the item is is defined in data/map.ts
export const MazePrefabs = [
  [
    "++++++++++",
    "+ &     &+",
    "+ & &&& &+",
    "+   &i  &+",
    "+ &&&&& &+",
    "+     & &+",
    "++++++++++",
  ],
  [
    "++++++++++",
    "+ &   & &+",
    "+ & &&& &+",
    "+ &    i&+",
    "+ & &&&&&+",
    "+       &+",
    "++++++++++",
  ],
  [
    "++++++++++",
    "+       &+",
    "+&&&&&& &+",
    "+   i&  &+",
    "+ &&& &&&+",
    "+       &+",
    "++++++++++",
  ],
  [
    "++++++++++",
    "+     & &+",
    "+ & &&& &+",
    "+ &   &i&+",
    "+&& & & &+",
    "+   &   &+",
    "++++++++++",
  ],
  [
    "++++++++++",
    "+     & &+",
    "+&&&& &i&+",
    "+   &   &+",
    "+&& & &&&+",
    "+       &+",
    "++++++++++",
  ],
  [
    "++++++++++",
    "+   &   &+",
    "+&& &&& &+",
    "+ &i  & &+",
    "+ & &&& &+",
    "+       &+",
    "++++++++++",
  ],
  [
    "++++++++++",
    "+     & &+",
    "+&& & & &+",
    "+   &i  &+",
    "+ & &&& &+",
    "+ &   & &+",
    "++++++++++",
  ],
  [
    "++++++++++",
    "+     & &+",
    "+&& &&& &+",
    "+ &i&   &+",
    "+ & &&& &+",
    "+       &+",
    "++++++++++",
  ],
  [
    "++++++++++",
    "+ & &   &+",
    "+ & &&& &+",
    "+   &i  &+",
    "+ &&&&& &+",
    "+       &+",
    "++++++++++",
  ],
  [
    "++++++++++",
    "+   &   &+",
    "+&& &&& &+",
    "+ i &   &+",
    "+&& & &&&+",
    "+       &+",
    "++++++++++",
  ],
]
